export const ROUTES = {
  HOME: '/',
  SERVICES: '/services',
  ABOUT: '/about',
  CONTACT: '/contact',
} as const;

export const NAVIGATION = [
  { path: ROUTES.HOME, label: 'Accueil' },
  { path: ROUTES.SERVICES, label: 'Services' },
  { path: ROUTES.ABOUT, label: 'À Propos' },
  { path: ROUTES.CONTACT, label: 'Contact' },
] as const;

export const COMPANY = {
  name: 'Aura Conciergerie',
  phone: '06 22 10 33 24',
  email: 'contact@aura-conciergerie.com',
  address: 'Le plan de la tour, 83120 France',
  social: {
    instagram: 'https://www.instagram.com/aura.conciergerie',
  },
} as const;